import React from 'react'
import { NavLink } from 'react-router-dom';

const ListOpdSakinah = ({ dataListOpd = [], yearconfig = new Date().getFullYear(), loading = false }) => {
    function formatAngka(num) {
        return Number(num.toFixed(2));
    }
    return (
        <div className="w-full flex flex-col justify-center px-3">
            <table className="w-full text-sm table-auto mb-4 mx-auto">
                <thead className="bg-primeColor1 text-white sticky top-0">
                    <tr>
                        <th className="border border-slate-500 w-[3%]" rowSpan="2">No</th>
                        <th className="border border-slate-500" rowSpan="2">Kode</th>
                        <th className="border border-slate-500" rowSpan="2">Nama OPD</th>
                        <th className="border border-slate-500" rowSpan="2">Jumlah<br /> Indikator</th>
                        <th className="border border-slate-500" colSpan="4">Keterisian Data</th>
                    </tr>
                    <tr>
                        <th className="border border-slate-500">Target</th>
                        <th className="border border-slate-500">(%)</th>
                        <th className="border border-slate-500">Realisasi</th>
                        <th className="border border-slate-500">(%)</th>
                    </tr>
                </thead>
                <tbody>
                    
                    {
                    loading ?
                    <tr>
                        <td className="border border-slate-500 py-2 px-5 bg-green-200" colSpan="100%">Loading...</td>
                    </tr>
                    : dataListOpd.map((item, index) => {
                        return (
                            <tr className="odd:bg-slate-200 hover:bg-red-500" key={index}>
                                <td className="border border-slate-500 text-right px-2">{index + 1}</td>
                                <td className="border border-slate-500 px-2">{item.kode_opd}</td>
                                <td className="border border-slate-500 px-2">
                                    <NavLink to={`/tahun/${yearconfig}/cpkess/data-capaian/${item.id}/${item.nama_opd}`}
                                        className="hover:text-blue-400 hover:font-semibold hover:underline"
                                    >
                                        {item.nama_opd}
                                    </NavLink>
                                </td>
                                <td className="border border-slate-500 text-right px-2">{item.jumlah_indikator}</td>
                                <td className="border border-slate-500 text-right px-2">{item.target_terisi}</td>
                                <td className="border border-slate-500 text-right px-2">{formatAngka(item.entrian_target)}</td>
                                <td className="border border-slate-500 text-right px-2">{item.realisasi_terisi}</td>
                                <td className="border border-slate-500 text-right px-2">{formatAngka(item.entrian_realisasi)}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
}

export default ListOpdSakinah